import React from 'react';
import { Field, FieldProps } from 'formik';
import clsx from 'clsx';
import { SearchSelectInput } from '../form-controls';
import { FormFieldError } from '../FormFields';
import { LabelPosition } from '../../types';

interface SearchSelectProps {
  label: string;
  name: string;
  labelPosition?: LabelPosition;
  isRequired?: boolean;
  disabled?: boolean;
  fieldWrapperClasses?: string;
}

export const FormikSearchSelect = ({
  name,
  label,
  labelPosition = LabelPosition.TOP,
  fieldWrapperClasses,
  ...props
}: SearchSelectProps) => {
  return (
    <div
      className={clsx('flex my-2', labelPosition === LabelPosition.TOP ? 'flex-col' : 'items-baseline justify-between')}
    >
      <label
        data-testid={`label-for-${name}`}
        className={clsx(
          'block mb-2 tracking-wide font-effra',
          labelPosition === LabelPosition.TOP ? 'text-sm font-bold' : 'text-base',
          props.disabled ? 'text-gray-20' : 'text-black-default'
        )}
        htmlFor={name}
      >
        {label}
        {props.isRequired && <span className='px-1'>*</span>}
      </label>
      <div className={fieldWrapperClasses}>
        <Field name={name}>
          {({ field, form, meta }: FieldProps) => {
            const changeHandler = ({ value }: { value: string }) => {
              form.setFieldValue(name, value);
            };
            return (
              <React.Fragment>
                <SearchSelectInput {...field} {...props} onSelect={changeHandler} />
                <FormFieldError field={field} meta={meta} />
              </React.Fragment>
            );
          }}
        </Field>
      </div>
    </div>
  );
};
